"use strict";
import * as Sentry from "@sentry/vue";
import fetchJsonWithTimeouts from "./fetchJsonWithTimeouts.js";

// Rules hosts can be unreachable from some regions (e.g. dl.scantrust.com from China),
// so a stalled fetch must not block the launch: time out and resolve with empty rules
// on failure.
const loadThirdPartyContentRules = async () => {
  try {
    return await fetchJsonWithTimeouts(import.meta.env.VITE_THIRD_PARTY_CONTENT_RULES_URL);
  } catch (err) {
    console.error("Third-party content rules loading error:", err);
    Sentry.captureException(new Error("Third-party content rules loading failed", { cause: err }));
    return {};
  }
};

const registerRules = (rules) => {
  if (typeof globalThis.wasmM === "undefined") {
    throw new Error("This function requires the wasm module to be available globally");
  }
  const wasmM = globalThis.wasmM;

  const rejectedEntries = { whitelist: [], blacklist: [] };
  if (rules["whitelist"]) {
    for (const domain in rules["whitelist"]) {
      const domainEntries = rules["whitelist"][domain];
      for (const { type, pattern, company_id } of domainEntries) {
        if (!wasmM.registerWhitelistedDomain(domain, wasmM.WhitelistType.values[type], pattern ? pattern : "", company_id ? company_id : -1)) {
          console.error(`Whitelist entry registration rejected: {${domain}, ${type}, ${pattern}, ${company_id}}`);
          rejectedEntries.whitelist.push(`{${domain}, ${type}, ${pattern}, ${company_id}}`);
        }
      }
    }
  }
  if (rules["blacklist"]) {
    for (const url in rules["blacklist"]) {
      const { type, company_id } = rules["blacklist"][url];
      if (!wasmM.registerBlacklistedUrl(url, wasmM.BlacklistType.values[type], company_id)) {
        console.error(`Blacklist entry registration rejected: {${url}, ${type}, ${company_id}}`);
        rejectedEntries.blacklist.push(`{${url}, ${type}, ${company_id}}`);
      }
    }
  }
  if (rejectedEntries.whitelist.length || rejectedEntries.blacklist.length) {
    Sentry.withScope((scope) => {
      scope.setContext("Error detail", {
        "rejected_whitelist_entries": rejectedEntries.whitelist,
        "rejected_blacklist_entries": rejectedEntries.blacklist
      });
      Sentry.captureException(new Error("Some third-party content rules entries failed to register"));
    });
  }
  return true;
};

export { loadThirdPartyContentRules, registerRules };
